import { Words, Wrapper } from "./style";
const WordCarousel = ({ text, words, fontSize, height }) => {
  return (
    <Wrapper fontSize={fontSize} height={height}>
      <p>{text}</p>
      <Words fontSize={fontSize}>
        {words.map((word, index) => {
          return <span className="highlight" key={`word-carousel-item-${index}`}>{word}</span>;
        })}
      </Words>
    </Wrapper>
  );
};

export default WordCarousel;
